/**
 * The query keys of one kind of server data, in one shape for every feature:
 *
 *   all        ["units"]                     everything of this kind
 *   lists()    ["units", "list"]             every list
 *   details()  ["units", "detail"]           every single item
 *   detail(id) ["units", "detail", 12]       one item
 *
 * Invalidating a shorter key refreshes everything under it. Lists are fetched whole (the API
 * does not paginate) and filtered in the browser, so a list key carries no filters.
 */
export function makeKeys<const Scope extends string>(scope: Scope) {
  const all = [scope] as const;
  return {
    all,
    lists: () => [...all, "list"] as const,
    details: () => [...all, "detail"] as const,
    detail: (id: number | string) => [...all, "detail", String(id)] as const,
  };
}
